// The pathname of the state currently rendered. Compared on popstate so only
// traversals that change the PATH (filter-hash steps pushed below) reload the
// document -- hash-only traversals (e.g. the retail user dashboard's #tab
// history entries) are same-document state and must not trigger a reload.
let rendered_pathname = window.location.pathname;

function update_url(resp) {
    if (window.history && "pushState" in window.history) {
        const url = resp.data.data.url;
        if (!url) return;
        window.history.pushState(null, "", url);
        rendered_pathname = window.location.pathname;
        const canonical = document.querySelector('link[rel="canonical"]');
        if (canonical !== null) {
            canonical.href = url;
        }
    }
}

// Matches elements bound to `form` both by DOM nesting and by the HTML `form="<id>"`
// attribute -- a panel needs the latter when it's placed outside the form's own DOM
// subtree to escape a z-index stacking trap (e.g. an ancestor .container with an
// explicit z-index that a same-valued, later-in-DOM sibling like Swiper's own
// .swiper{z-index:1} would otherwise paint over).
function formScopedElements(form, selector) {
    const descendants = Array.from(form.querySelectorAll(selector));
    if (!form.id) return descendants;
    const external = Array.from(document.querySelectorAll(`[form="${form.id}"]`)).filter((el) => el.matches(selector));
    return descendants.concat(external);
}

function groupBy(objectArray, property, value) {
    return objectArray.reduce(function (acc, obj) {
        const key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj[value]);
        return acc;
    }, {});
}

function getFormData(filter_form) {
    let formData = new FormData(filter_form);
    let object = [];
    formData.forEach(function (value, key) {
        const o = {
            name: key,
            value: value,
        };
        object.push(o);
    });

    // FormData silently skips disabled elements -- if a rapid second change fires while a
    // prior request's oiFilterDisableForm() is still in effect, fields like hidden inputs
    // or a <select> (e.g. plan_collection re-picked before the previous request's 500ms
    // re-enable delay elapses) would drop out entirely. Neither is meant to be "locked" for
    // user feedback anyway, so read them straight off the DOM regardless of disabled state.
    formScopedElements(filter_form, 'input[type="hidden"], select').forEach(function (input) {
        object = object.filter(function (o) { return o.name !== input.name; });
        object.push({ name: input.name, value: input.value });
    });

    const pieces = groupBy(object, "name", "value");
    formData = new FormData();
    for (const piece in pieces) {
        if (pieces.hasOwnProperty(piece)) {
            formData.append(piece, pieces[piece].join("|"));
        }
    }
    return formData;
}

function oiFilterDisableForm(oi_filter_form) {
    if (oi_filter_form) {
        let i;
        // Disable all form inputs
        for (i = 0; i < oi_filter_form.elements.length; i++) {
            oi_filter_form.elements[i].setAttribute("disabled", "disabled");
        }
        // Disable all elements with class of "oi-disable-while-pending"
        const to_disable = document.getElementsByClassName("oi-disable-while-pending");
        for (i = 0; i < to_disable.length; i++) {
            to_disable[i].setAttribute("disabled", "disabled");
        }
        // Reduce the opacity of all elements with class of "model-filters"
        const model_filters = document.getElementsByClassName("model-filters");
        for (i = 0; i < model_filters.length; i++) {
            model_filters[i].style.opacity = "0.6";
        }
    }
}

function oiFilterEnableForm(oi_filter_form) {
    if (oi_filter_form) {
        setTimeout(function () {
            let i;
            // Remove the disabled attribute and value from inputs.
            for (i = 0; i < oi_filter_form.elements.length; i++) {
                oi_filter_form.elements[i].disabled = false;
                oi_filter_form.elements[i].removeAttribute("disabled");
            }
            // Remove disabled from all elements with class of "oi-disable-while-pending"
            const to_disable = document.getElementsByClassName("oi-disable-while-pending");
            for (i = 0; i < to_disable.length; i++) {
                to_disable[i].disabled = false;
                to_disable[i].removeAttribute("disabled");
            }
            // Reset the opacity of all elements with class of "model-filters"
            const model_filters = document.getElementsByClassName("model-filters");
            for (i = 0; i < model_filters.length; i++) {
                model_filters[i].style.opacity = "1";
            }
        }, 500);
    }
}

function oiFilterAjaxBeforesend(oi_filter_form, from_infinite) {
    if (from_infinite === undefined || from_infinite === false) {
        oiFilterDisableForm(oi_filter_form);
    }
}

function oiFilterGetResults(oi_filter_form, results, from_infinite) {
    let ftype = oi_filter_form.dataset.filterType;
    let redirecting = false;
    const url = `/xhr/filter/${ftype}/`;
    const append_mode = from_infinite === true;

    // Guard against out-of-order responses: if another request is fired on this same
    // form before this one resolves (rapid tab/card clicks), only the response for the
    // most recently issued request should ever touch the DOM.
    oi_filter_form._oiFilterRequestId = (oi_filter_form._oiFilterRequestId || 0) + 1;
    const requestId = oi_filter_form._oiFilterRequestId;

    if (!append_mode) {
        // Filter change, reset button, or click trigger — always start from page 1,
        // even if the user had already scrolled several pages deep via infinite
        // scroll. Must happen before getFormData() reads the form below, since
        // infinite-scroll appends (oiObserveSentinel) advance this same input to
        // the next page and never reset it back down afterward.
        const pageInput = oi_filter_form.querySelector('input[name="page"]');
        if (pageInput) pageInput.value = "1";
    }

    const formData = getFormData(oi_filter_form);
    const detailPage = oi_filter_form.dataset.detailPage ? oi_filter_form.dataset.detailPage : false;
    oi.axios({
        method: "post",
        url: url,
        data: formData,
        headers: {
            "Content-Type": "application/json",
        },
        transformRequest: [
            function (data, headers) {
                oiFilterAjaxBeforesend(oi_filter_form, from_infinite);
                return data;
            },
        ],
    })
        .then(function (resp) {
            if (oi_filter_form._oiFilterRequestId !== requestId) return; // a newer request superseded this one
            if (resp.data.data.result_list) {
                if (resp.data.options) {
                    const options = resp.data.options;
                    for (const id in options) {
                        // Skip ids this page doesn't render -- a null deref here
                        // would abort the rest of the handler and leave the
                        // results, count, and map un-updated.
                        const target = document.getElementById(id);
                        if (target) target.innerHTML = options[id];
                    }
                }

                if (append_mode) {
                    // Scroll-triggered load-more: append new cards, update/remove sentinel
                    const tmp = document.createElement("div");
                    tmp.innerHTML = resp.data.data.result_list;

                    // Pages with more than one parallel result layout (e.g. a Grid/List
                    // view toggle) mark each layout's row-container with
                    // data-append-target="<key>" so each gets its own new items appended
                    // -- a single generic ".row" lookup would only ever find the first
                    // one and silently drop appends into any other layout.
                    const tmpTargets = tmp.querySelectorAll("[data-append-target]");

                    if (tmpTargets.length) {
                        tmpTargets.forEach((tmpTarget) => {
                            const key = tmpTarget.dataset.appendTarget;
                            const existingTarget = results.querySelector(`[data-append-target="${key}"]`);
                            if (existingTarget) {
                                Array.from(tmpTarget.children).forEach((child) => existingTarget.appendChild(child));
                            }
                        });
                    } else {
                        // Default: a single ".row" -- every other filtered page in the theme.
                        const tmpRow = tmp.querySelector(".row");
                        const existingRow = results.querySelector(".row");
                        if (existingRow && tmpRow) {
                            Array.from(tmpRow.children).forEach((card) => existingRow.appendChild(card));
                        } else if (tmpRow) {
                            results.insertAdjacentHTML("beforeend", resp.data.data.result_list);
                        }
                    }

                    // Update or remove the sentinel
                    const oldSentinel = results.querySelector("#load-more-sentinel");
                    if (oldSentinel) oldSentinel.remove();

                    const newSentinel = tmp.querySelector("#load-more-sentinel");
                    if (newSentinel) {
                        results.appendChild(newSentinel);
                        oiObserveSentinel(oi_filter_form, results, newSentinel);
                    }
                } else {
                    // Filter change: replace all results (page input was already reset to 1 above)
                    results.innerHTML = resp.data.data.result_list;

                    // Wire up the new sentinel if present
                    const sentinel = results.querySelector("#load-more-sentinel");
                    if (sentinel) {
                        oiObserveSentinel(oi_filter_form, results, sentinel);
                    }

                    if (resp.data.data.paginator) {
                        // Update page input for next load-more
                        const pageInput = oi_filter_form.querySelector('input[name="page"]');
                        if (pageInput && resp.data.data.paginator.next) {
                            pageInput.value = resp.data.data.paginator.next;
                        }
                    }
                }

                const oi_filter_amount = document.getElementById("oi-filter-amount");
                if (oi_filter_amount !== null && resp.data.data.amount) {
                    oi_filter_amount.innerHTML = resp.data.data.amount;
                }
                document.querySelectorAll(".oi-filter-amount").forEach((el) => {
                    el.textContent = resp.data.data.amount ?? 0;
                });

                if (resp.data.result_list_lot) {
                    const results_lot = document.getElementById("oi-filter-results-lot");
                    results_lot.innerHTML = resp.data.result_list;
                }
                if (resp.data.result_list_land) {
                    const results_land = document.getElementById("oi-filter-results-land");
                    results_land.innerHTML = resp.data.result_list;
                }

                // get_map_items() only returns rows on page 1 (see its docstring) --
                // map_items_template still renders on page 2+ of a load-more, just as
                // whitespace, which is indistinguishable from a genuine zero-result
                // page 1 by content alone. Gate on append_mode (already tracks exactly
                // that distinction, like skipMapRefresh below) instead of the rendered
                // string, so a real "no matches" filter correctly clears the map.
                if (!append_mode) {
                    const map_items = document.querySelector(".oi-all-map-items");
                    if (map_items) map_items.innerHTML = resp.data.data.map_items;
                }

                if (!append_mode) {
                    update_url(resp);

                    // Per-form event so each section can react to its own swap (e.g. reinit a Swiper).
                    oi_filter_form.dispatchEvent(new CustomEvent("oi-filter-results-updated", { detail: { amount: resp.data.data.amount } }));
                }

                if (window.afterResultsSuccess !== undefined) {
                    window.afterResultsSuccess();
                }

                const skipMapRefresh = append_mode && (ftype === "spec" || ftype === "location");

                if (oi.loaded.map["oi-map"] && !detailPage && !skipMapRefresh) {
                    if (ftype === "lot" || ftype === "mlslisting") {
                        ftype = "location";
                    }
                    var mapInst = oi.loaded.map["oi-map"];
                    mapInst.set_markers(ftype);
                    mapInst.fit();
                    // .fit() just fitBounds()-ed to the filtered results, which
                    // can zoom in very tight when only a few are left nearby
                    // each other. fitBounds() sets the resulting zoom
                    // synchronously, so just correct it right after (see
                    // fitBoundsCapped in map_search.js) without capping the
                    // map's zoom generally.
                    var gmap = mapInst.map || mapInst.vendor_implementation?.map;
                    if (gmap && gmap.getZoom() > 14) gmap.setZoom(14);
                }
            }
        })
        .catch(function (error) {
            if (error.response) {
                if (error.response.status == 400) {
                    let msg = "";
                    const errors = error.response.data.errors;
                    for (let err in errors) {
                        let x = errors[err];
                        msg = `${x.code} - ${x.description}\n`;
                    }
                    oiFilterEnableForm(oi_filter_form);
                } else if (error.response.status == 302) {
                    // Navigation is underway -- leave the form disabled so the controls
                    // don't flash back to interactive while the new page loads.
                    redirecting = true;
                    window.location.href = error.response.data.data.redirect;
                }
            } else if (error.request) {
                console.error(error.request);
            } else {
                console.error(error.message);
            }
        })
        .then(function () {
            if (redirecting) return;

            const name_input = oi_filter_form.querySelector('input[name="m"]');
            if (name_input !== null) {
                name_input.value = "0";
            }
            oiFilterEnableForm(oi_filter_form);
        });
}

function oiObserveSentinel(oi_filter_form, results, sentinel) {
    if (!sentinel || !("IntersectionObserver" in window)) return;

    const observer = new IntersectionObserver(
        function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    const nextPage = sentinel.dataset.nextPage;
                    if (!nextPage) return;

                    observer.unobserve(sentinel);

                    const pageInput = oi_filter_form.querySelector('input[name="page"]');
                    if (pageInput) pageInput.value = nextPage;

                    oiFilterGetResults(oi_filter_form, results, true);
                }
            });
        },
        { rootMargin: "0px 0px 200px 0px" },
    );

    observer.observe(sentinel);
}

document.addEventListener(
    "mouseenter",
    function (e) {
        if (!(e.target instanceof Element)) return;
        const card = e.target.closest("[data-listing-id]");
        if (!card) return;

        const filterForm = document.getElementById("oi-filter-form");
        if (!filterForm || (filterForm.dataset.filterType !== "spec" && filterForm.dataset.filterType !== "location")) return;

        const mapInst = oi.loaded.map && oi.loaded.map["oi-map"];
        if (!mapInst) return;

        mapInst.show_infowindow(card.dataset.listingId);
    },
    true,
);

// Price/Bedrooms/Bathrooms also exist as plain selects in the sticky bar
// (#desktop-filters); dragging a slider here clears the matching sticky-bar select.
const STICKY_SELECT_BY_RANGE_FIELD = {
    price_range: "price",
    bedrooms_range: "bedrooms",
    bathrooms_range: "bathrooms",
};
// The reverse lookup (sticky-bar select name -> its range field), derived
// from the map above so the two directions can't drift out of sync.
const RANGE_FIELD_BY_STICKY_SELECT = Object.fromEntries(
    Object.entries(STICKY_SELECT_BY_RANGE_FIELD).map(([rangeField, stickyField]) => [stickyField, rangeField]),
);

// Shared ionRangeSlider init for all "*_range" filter partials. Reads config from
// data-slider-* attrs (not the library's own data-min/max) to avoid string coercion.
function initRangeSliders() {
    document.querySelectorAll(".js-range-slider").forEach((input) => {
        const wrap = input.closest(".range-slider-wrap");
        const hiddenInput = wrap && wrap.querySelector('input[type="hidden"].oi-filter-change');
        if (!hiddenInput) return;

        const options = {
            skin: "round",
            type: "double",
            min: Number(input.dataset.sliderMin),
            max: Number(input.dataset.sliderMax),
            step: Number(input.dataset.sliderStep) || 1,
            values_separator: "-",
            input_values_separator: "-",
            hide_min_max: true,
            force_edges: true,
            extra_classes: "irs-custom",
            onFinish: function (data) {
                // Clear (rather than submit "%min-max") at full range, since the
                // server-side filter would otherwise wrongly exclude plan-less rows.
                const atFullRange =
                    Number(data.from) === Number(input.dataset.sliderMin) &&
                    Number(data.to) === Number(input.dataset.sliderMax);
                hiddenInput.value = atFullRange ? "" : "%" + data.from + "-" + data.to;

                const stickyFieldName = STICKY_SELECT_BY_RANGE_FIELD[hiddenInput.name];
                if (stickyFieldName) {
                    const oiFilterForm = hiddenInput.closest("form");
                    const mirror = oiFilterForm && oiFilterForm.querySelector(`input[name="${stickyFieldName}"]`);
                    if (mirror) mirror.value = "";

                    const stickySelect = document.querySelector(`#desktop-filters select[name="${stickyFieldName}"]`);
                    if (stickySelect) stickySelect.selectedIndex = 0;
                }

                hiddenInput.dispatchEvent(new Event("change"));
            },
        };
        if (input.dataset.sliderDisable === "true") options.disable = true;
        if (input.dataset.sliderPrefix) options.prefix = input.dataset.sliderPrefix;
        if (input.dataset.sliderMaxPostfix) options.max_postfix = input.dataset.sliderMaxPostfix;
        if (input.dataset.sliderPrettify === "true") options.prettify_separator = ",";

        const slider = ionRangeSlider(input, options);
        // Both exposed so the sticky-bar bridge can drive this slider's handles when
        // its plain-select counterpart is used. The bounds have to be stashed here:
        // the slider instance's public API is only {update, reset, destroy, init} and
        // carries no min/max of its own.
        hiddenInput.rangeSlider = slider;
        hiddenInput.rangeSliderBounds = { min: options.min, max: options.max };

        // Sync the slider handles to the filter's currently-applied value, or
        // to the full range if no filter is applied yet.
        syncSliderToValue(hiddenInput);
    });
}

document.addEventListener("DOMContentLoaded", initRangeSliders);

// Keep the sticky bar (#desktop-filters) and off-canvas modal (#oi-filter-form)
// in sync by field name. Most fields just mirror their value both ways; Price/
// Bedrooms/Bathrooms are mutually exclusive (sticky plain select vs. modal range
// slider).
//
// This bridge is the *only* thing that makes the sticky bar work -- the load
// handler below binds .oi-filter-change within #oi-filter-form alone, and the bar
// lives in #oi-filter-form-partial, which is never bound or posted. So every name
// in the bar needs a same-named target in the off-canvas (see filter_fields.py).
function initStickyBarSync() {
    const filtersEl = document.getElementById("desktop-filters");
    const oiFilterFormEl = document.getElementById("oi-filter-form");
    if (!filtersEl || !oiFilterFormEl) return;

    const form1Selects = filtersEl.querySelectorAll("select");

    form1Selects.forEach((select1) => {
        const rangeFieldName = RANGE_FIELD_BY_STICKY_SELECT[select1.name];

        if (rangeFieldName) {
            const mirror = oiFilterFormEl.querySelector(`input[name="${select1.name}"]`);
            if (!mirror) return;

            select1.addEventListener("change", () => {
                mirror.value = select1.value;

                const rangeInput = oiFilterFormEl.querySelector(`input[name="${rangeFieldName}"]`);
                if (rangeInput) {
                    rangeInput.value = "";
                    syncSliderToValue(rangeInput);
                }

                mirror.dispatchEvent(new Event("change"));
            });
            return;
        }

        // Matches any named control, not just <select> -- Square Footage pairs a bar
        // select against the off-canvas slider's hidden input. Unlike Price/Bedrooms/
        // Bathrooms (handled above), those two share ONE field name, so they're two
        // controls on the same value and genuinely mirror instead of clearing.
        const counterpart = oiFilterFormEl.querySelector(`[name="${select1.name}"]`);
        if (!counterpart) return;

        select1.addEventListener("change", () => {
            counterpart.value = select1.value;
            syncSliderToValue(counterpart);
            counterpart.dispatchEvent(new Event("change"));
        });
        counterpart.addEventListener("change", () => {
            // A slider reports an arbitrary "%from-to" that rarely matches a bucket
            // option. Assigning an unmatched value leaves selectedIndex at -1, which
            // renders the select completely empty -- fall back to the placeholder so
            // it reads "Sq.Ft." rather than looking broken.
            select1.value = counterpart.value;
            if (select1.selectedIndex === -1) select1.selectedIndex = 0;
        });
    });
}

// Move a range slider's handles to match its hidden input's "%from-to" value, or back
// to full range when that value is blank. No-op for plain selects (no attached slider).
function syncSliderToValue(rangeInput) {
    const slider = rangeInput.rangeSlider;
    const bounds = rangeInput.rangeSliderBounds;
    if (!slider || !bounds) return;

    if (rangeInput.value) {
        const [from, to] = rangeInput.value.slice(1).split("-");
        slider.update({ from: from, to: to });
    } else {
        slider.update({ from: bounds.min, to: bounds.max });
    }
}

document.addEventListener("DOMContentLoaded", initStickyBarSync);

// Where a form has BOTH a plain "@N+" select (e.g. name="bedrooms") and that same
// field's dual-handle range slider (name="bedrooms_range") -- e.g. a primary filter
// bar plus a "More Filters" off-canvas in one form. Picking "4+" in the select mirrors
// onto the slider as [4, its own max] -- equivalent to "4+" since that max already is the
// data's real ceiling -- so the off-canvas shows the same choice already made. Dragging
// the slider to something the select can't express clears the select instead, since at
// that point the slider is the more specific, active constraint.
function initFieldRangeSync(oi_filter_form) {
    formScopedElements(oi_filter_form, "select[name]").forEach((select) => {
        const rangeInput = formScopedElements(oi_filter_form, `input[name="${select.name}_range"]`)[0];
        if (!rangeInput) return;

        select.addEventListener("change", () => {
            if (select.value.startsWith("%")) {
                // Price's plain select already posts a "%low-high" bucket -- same
                // format the slider stores, so just carry it over as-is.
                rangeInput.value = select.value;
            } else {
                const bounds = rangeInput.rangeSliderBounds;
                const match = select.value.match(/^@(\d+)/);
                rangeInput.value = match && bounds ? `%${match[1]}-${bounds.max}` : "";
            }
            syncSliderToValue(rangeInput);
        });
        rangeInput.addEventListener("change", () => {
            if (rangeInput.value) select.selectedIndex = 0;
        });
    });
}

// A field with no range-slider counterpart (e.g. home_type) that's shown in both the
// primary bar and the off-canvas has two identically-named selects. Submitting both
// would join them with "|" in FormData and break the filter, so only the first (the
// primary bar's) actually submits -- the rest just mirror its value both ways.
function initDuplicateNameMirrors(oi_filter_form) {
    const byName = {};
    formScopedElements(oi_filter_form, "select[name]").forEach((el) => {
        (byName[el.name] = byName[el.name] || []).push(el);
    });
    Object.values(byName).forEach(([primary, ...mirrors]) => {
        mirrors.forEach((mirror) => {
            mirror.removeAttribute("name");
            mirror.classList.remove("oi-filter-change");
            mirror.value = primary.value;
            mirror.addEventListener("change", () => {
                primary.value = mirror.value;
                primary.dispatchEvent(new Event("change"));
            });
            primary.addEventListener("change", () => {
                mirror.value = primary.value;
            });
        });
    });
}

// Search by Map's "filters-offcanvas": all 5 filters (market/price/county/city/home_type)
// live-update the map's pins/zoom and each other's options in place -- this panel never
// redirects. Scoped to #filters-offcanvas specifically -- the Collection List page's
// "Region" select shares the same market.html partial/name="market" and must not trigger this.
function initSearchMapFilters() {
    const offcanvas = document.getElementById("filters-offcanvas");
    if (!offcanvas) return;
    const marketSelect = offcanvas.querySelector('select[name="market"]');
    if (!marketSelect) return;

    const dependentFields = ["city", "price", "home_type", "county"];
    const allFields = ["market", ...dependentFields];
    const placeholderText = {
        city: "Select City",
        price: "Price Range",
        home_type: "Home Type",
        county: "Select County",
    };

    const resultCountEl = document.getElementById("search-map-result-count");

    function fieldSelect(name) {
        return offcanvas.querySelector(`select[name="${name}"]`);
    }

    function showResultCount(count) {
        if (count == null) {
            resultCountEl?.classList.add("d-none");
            return;
        }
        if (resultCountEl) {
            resultCountEl.textContent = `${count} home${count === 1 ? "" : "s"} found`;
            resultCountEl.classList.remove("d-none");
        }
    }

    function handleFilterChange(changedField) {
        if (changedField === "market") {
            // A market switch invalidates whatever was picked in a different market.
            dependentFields.forEach((name) => {
                const sel = fieldSelect(name);
                if (sel) {
                    sel.value = "";
                    sel.disabled = true;
                }
            });
        } else {
            dependentFields.forEach((name) => {
                const sel = fieldSelect(name);
                if (sel) sel.disabled = true;
            });

            if (changedField === "county") {
                // City is scoped by County (see AjaxHomeMarketOptionsView) -- clear it before
                // building the request below so a stale City from a *different* county isn't
                // combined with the new County filter and (likely) matches nothing.
                const citySelect = fieldSelect("city");
                if (citySelect) citySelect.value = "";
            }
        }

        if (!marketSelect.value) {
            showResultCount(null);
            return;
        }

        const formData = new FormData();
        allFields.forEach((name) => {
            const sel = fieldSelect(name);
            if (sel) formData.append(name, sel.value);
        });

        oi.axios({
            method: "post",
            url: "/xhr/filter/homepage/market-options/",
            data: formData,
        })
            .then((resp) => {
                dependentFields.forEach((name) => {
                    const sel = fieldSelect(name);
                    const optionsHtml = resp.data.data[name];
                    if (sel && optionsHtml !== undefined) {
                        sel.innerHTML = optionsHtml;
                        sel.disabled = false;
                    }
                });

                showResultCount(resp.data.data.result_count ?? 0);

                if (typeof window.zoomAllSearchMapsToMarket === "function") {
                    // zero_result_center lets the map center on the actual County/City picked
                    // (rather than the market's own office coordinates) when nothing matches,
                    // so a user familiar with the area isn't left disoriented about where
                    // "zero results" is -- see zoomAllSearchMapsToMarket in map_search.js.
                    window.zoomAllSearchMapsToMarket(
                        marketSelect.value,
                        resp.data.data.location_pins || [],
                        resp.data.data.zero_result_center,
                    );
                }
            })
            .catch((error) => {
                // Leave dependent selects disabled with a bare placeholder rather than stuck
                // showing stale options with no way to reset. Don't touch the map -- leave its
                // last-good state rather than clearing it on a transient request failure.
                dependentFields.forEach((name) => {
                    const sel = fieldSelect(name);
                    if (sel) {
                        sel.innerHTML = `<option value="">${placeholderText[name]}</option>`;
                        sel.disabled = true;
                    }
                });
                if (error.response) {
                    console.error(error.response);
                } else if (error.request) {
                    console.error(error.request);
                } else {
                    console.error(error.message);
                }
            });
    }

    marketSelect.addEventListener("change", () => handleFilterChange("market"));
    dependentFields.forEach((name) => {
        fieldSelect(name)?.addEventListener("change", () => handleFilterChange(name));
    });

    // Mirrors the list pages' "Clear Filters" link, but resets in place instead of
    // navigating, and also forwards to the existing "Reset Map" button so both controls
    // do the same thing (no map instance needs its own copy of that reset logic).
    document.getElementById("btn-reset-search-map-filters")?.addEventListener("click", () => {
        marketSelect.value = "";
        dependentFields.forEach((name) => {
            const sel = fieldSelect(name);
            if (sel) {
                sel.value = "";
                sel.disabled = true;
            }
        });
        showResultCount(null);
        document.getElementById("btn-reset-map")?.click();
    });
}

document.addEventListener("DOMContentLoaded", initSearchMapFilters);

// The bfcache preserves stale <select> values across back/forward navigation & since filter submits send the form's
// FULL state, that staleness can override the next unrelated filter change. Reset on persisted pageshow.
window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
        document.querySelectorAll(".oi-filter-form").forEach((oi_filter_form) => {
            oi_filter_form.reset();
            // reset() restores values, not the disabled attribute a redirect left behind.
            oiFilterEnableForm(oi_filter_form);
        });
    }
});

window.addEventListener("load", () => {
    // Single-form pages fall back to #oi-filter-results; multi-form pages (e.g. Location
    // Detail's tabs) set data-results-target per form instead.
    document.querySelectorAll(".oi-filter-form").forEach((oi_filter_form) => {
        const resultsTarget = oi_filter_form.dataset.resultsTarget;
        const oi_filter_results = resultsTarget
            ? document.querySelector(resultsTarget)
            : document.getElementById("oi-filter-results");
        if (!oi_filter_results) return;

        initFieldRangeSync(oi_filter_form);
        initDuplicateNameMirrors(oi_filter_form);

        const oi_filter_clickables = formScopedElements(oi_filter_form, ".oi-filter-click");
        const oi_filter_changables = formScopedElements(oi_filter_form, ".oi-filter-change");

        oi_filter_clickables.forEach((elem) => {
            elem.addEventListener("click", (e) => {
                e.preventDefault();
                oiFilterGetResults(oi_filter_form, oi_filter_results);
            });
        });

        oi_filter_changables.forEach((elem) => {
            elem.addEventListener("change", (e) => {
                e.preventDefault();
                oiFilterGetResults(oi_filter_form, oi_filter_results);
            });
        });

        const oi_filter_reset = formScopedElements(oi_filter_form, ".oi-filter-reset");
        if (oi_filter_reset !== null && oi_filter_results !== null) {
            oi_filter_reset.forEach((btn) => {
                btn.addEventListener("click", (e) => {
                    let i;
                    e.preventDefault();
                    // Scoped to this form so resetting one section doesn't clear another's.
                    const to_clear = formScopedElements(oi_filter_form, ".oi-clear-on-reset");
                    if (to_clear) {
                        for (i = 0; i < to_clear.length; i++) {
                            if (to_clear[i].type == "select-one") {
                                to_clear[i].selectedIndex = 0;
                            }
                            if (to_clear[i].id == "boyl-input") {
                                to_clear[i].value = false;
                            }
                            if (to_clear[i].type == "checkbox") {
                                to_clear[i].checked = false;
                            }
                            // Range slider's hidden value -- also resets the visible slider handles.
                            if (to_clear[i].rangeSlider !== undefined) {
                                to_clear[i].value = "";
                                syncSliderToValue(to_clear[i]);
                            }
                        }
                    }
                    const buttons_to_reset = formScopedElements(oi_filter_form, ".filter-button-on");
                    if (buttons_to_reset) {
                        for (i = 0; i < buttons_to_reset.length; i++) {
                            buttons_to_reset[i].classList.remove("filter-button-on");
                        }
                    }
                    oiFilterGetResults(oi_filter_form, oi_filter_results);
                });
            });
        }

        // Wire up load-more sentinel on initial page load
        const initial_sentinel = oi_filter_results.querySelector("#load-more-sentinel");
        if (initial_sentinel) {
            oiObserveSentinel(oi_filter_form, oi_filter_results, initial_sentinel);
        }
    });

    window.addEventListener("popstate", (e) => {
        // Reload only when the traversal changed the pathname (moving between
        // filter-hash URLs), so the server re-renders that filter state.
        // Same-pathname popstates (hash tabs, Safari's on-load popstate)
        // otherwise force a full reload of pages that don't need one.
        if (window.location.pathname === rendered_pathname) {
            return;
        }
        location.reload();
    });
});
